import WikiPage from "./WikiPage"

export default WikiPage
